<template>
  <product-card-box v-if="product.refund_policy && isLogin" id="visa-refund-policy" title="退款政策">
    <div class="policy-list">
      <div class="policy-item" v-for="(item, index) in product.refund_policy.content" :key="index">
        <div class="policy-step"></div>
        <div class="item-text">{{item}}</div>
      </div>
    </div>
  </product-card-box>
</template>

<script>
import User from '@/libs/user';
import ProductCardBox from './product-card-box.vue';

export default {
  components: {
    ProductCardBox,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLogin: User.isLogin(),
    };
  },
};
</script>

<style scoped lang="less">
.policy-list{
  position: relative;
  z-index: 1;

  .policy-item{
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    &:last-child{
      margin-bottom: 0;
    }
    .policy-step{
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      background: url(https://o.666visa.cn/static/ssqpeer/product/icon-refund-policy-item-1.png) no-repeat center / 100% 100%;
      margin-right: 12px;
      margin-top: 4px;
    }
    .item-text{
      flex-grow: 1;
      white-space: pre-wrap;
      word-break: break-word;
      color: #5F666E;
      font-size: 14px;
      line-height: 24px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-refund-policy.vue